import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BookingService } from '../../_LOGIC/booking.service';
import { ResolverService } from 'src/app/_LOGIC/__common/resolver.service';
import { GuiFlowManagerService } from 'src/app/_LOGIC/__gui/gui-flow-manager.service';

declare var $:any;

@Component({
  selector: 'app-pricing-plans',
  templateUrl: './pricing-plans.component.html',
  styleUrls: ['./pricing-plans.component.css']
})
export class PricingPlansComponent implements OnInit {

  /* https://codepen.io/imanirudh1/pen/OJbeLGP */

  @Input() packages;
  @Input() myRouteId;

  nextButton;
  prevButton;
  loading = false;

  cards = [
    {
      title: 'Estudios, cursos y becas...',
      section: 'academic',
      category: 'Acedémico',
      img: "assets/voyjaleas/academic.jpeg",
      selected: true,
    }
  ];
  
  constructor(private router: Router,private bookingService: BookingService,private resolver: ResolverService,private guiFlow: GuiFlowManagerService) { }

  ngOnInit(): void {

    // external js: flickity.pkgd.js
    $(document).ready(() => {
      $('.carousel').flickity();
      this.nextButton = document.querySelector('.flickity-button.flickity-prev-next-button.next');
      this.prevButton = document.querySelector('.flickity-button.flickity-prev-next-button.previous');

      let self = this;
      $('.carousel').on( 'change.flickity', function( event, index ) {
        //console.log( 'Slide changed to ' + index );
      });
      
    })
  }

  getOldPrice(price){
    price = parseInt(price) + 20;
    return price;
  }

  goToPage(page){
    this.router.navigateByUrl(page);
  }
  
  hasInfo(){
    return this.packages && this.packages.length>0;
  }

  getCssClass(pack){
    if(pack.name == "Premium"){
      return 'card active';
    }else{
      return 'card shadow';
    }
  }

  isPackChosen(pack){
    if(pack && pack.FK_ID_package_chosen){
      return pack.FK_ID_package_chosen == pack.id
    }else{
      return false;
    }
  }

  getPackagesByType(){
    let basic = {};
    let premium = {};
    let full = {};
    
    if(this.packages){
      for(let item of JSON.parse(this.packages)){
        if(item.package_type === 'basic'){
            basic['price'] = item.price;
            basic['paid'] = item.paid;
            basic['id'] = item.id;
            basic['name'] = item.name;
            basic['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
        if(item.package_type === 'premium'){
          premium['price'] = item.price;
          premium['paid'] = item.paid;
          premium['id'] = item.id;
          premium['name'] = item.name;
          premium['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
        if(item.package_type === 'full'){
          full['price'] = item.price;
          full['paid'] = item.paid;
          full['id'] = item.id;
          full['name'] = item.name;
          full['FK_ID_package_chosen'] = item.FK_ID_package_chosen;
        }
      }

      let arrayResult = [];
      basic['products'] = this.resolver.getCachePacks()[0]['products'];
      premium['products'] = this.resolver.getCachePacks()[1]['products'];
      full['products'] = this.resolver.getCachePacks()[2]['products'];
      arrayResult.push(basic);
      arrayResult.push(premium);
      arrayResult.push(full);

      
      return arrayResult;
    }else{
      return []
    }
  }

  bookNow(pak){
    let obj = {
      type: 'pack',
      data: pak
    };
    this.bookingService.addToCart(obj)
    this.guiFlow.openSimpleSnackBar('Añadido al carro de compras','Ok');
    /* this.router.navigateByUrl('book'); */
  }

}
